module.exports = __webpack_public_path__ + "img/template-4.b3271620.webp";